import { addableKinds, kindMeta } from './destination-kinds';
import type { PaigeDestinationKind } from './paige.global';

/**
 * The ways to add a destination under the list in the "Send results to" card; `kinds` narrows them
 * to what this Paige offers (a storage kind only where its sign-in is set up).
 */
export function AddDestinationButtons({
  onAdd,
  kinds = addableKinds,
}: {
  onAdd: (kind: PaigeDestinationKind) => void;
  kinds?: readonly PaigeDestinationKind[];
}) {
  return (
    <span className="paige-destination-add">
      {kinds.map((kind) => (
        <button key={kind} type="button" className="quiet-button small" onClick={() => onAdd(kind)}>
          {kindMeta[kind].button}
        </button>
      ))}
    </span>
  );
}
